import { configure } from 'instantsearch.js/es/widgets';
import Cookie from 'global_critical/od/Cookie';

function areMarketingCookiesEnabled() {
	const consent = Cookie.get('OptanonConsent');
	if (!consent) return false;
	const marketingCookiePattern = /C0004%3A1/;
	return marketingCookiePattern.test(consent);
}

export const configureWidget = configure({
	filters: 'includeInResults:true',
	facets: ['*'],
	maxValuesPerFacet: 100,
	enablePersonalization: areMarketingCookiesEnabled(),
});
